export default __webpack_public_path__ + "static/media/downArrow.a646d7da.svg";